import { createDynamicSlice } from ".";
import {GetAllProductDomains, GetParentByDomain, sellerProductCategoriesThunk } from "../thunks/sellerProductCategoriesThunk";

const sellerProductCategoriesSlice = createDynamicSlice({
  name: "sellerProductCategoriesSlice",
  thunk: sellerProductCategoriesThunk,
});

const allProductDomainsSlice = createDynamicSlice({
  name: "allProductDomainsSlice",
  thunk: GetAllProductDomains,
});

const parentByDomainSlice = createDynamicSlice({
  name: "parentByDomainSlice",
  thunk: GetParentByDomain,
});

export const sellerProductCategoriesReducer =  sellerProductCategoriesSlice.reducer;
export const allProductDomainsReducer = allProductDomainsSlice.reducer;
export const parentByDomainReducer = parentByDomainSlice.reducer;